// This file uses CommonJS exports because it's imported from both frontend and NodeJS apps

export const s3DataPrefix = 'lp-data';
